/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class OperationRegionModel {
    getFixupPrototypeFunction() { return OperationRegionModel.fixupPrototype; }

    static newInstance(model: Partial<OperationRegionModel>): OperationRegionModel {
        let obj = Object.assign(new OperationRegionModel(), model);
        OperationRegionModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<OperationRegionModel>): OperationRegionModel {
        if (!model) return null;
        return OperationRegionModel.newInstance(<OperationRegionModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: OperationRegionModel) {
        if (!obj) return;

        models.OperationRegionModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: OperationRegionModel): boolean {
        Object.setPrototypeOf(obj, OperationRegionModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.count === undefined) {
            this.count = 0;
        }
    }

    /**
     * region name
     */
    region: string;

    /**
     * total count details
     */
    count: number;

}
